import { combineReducers } from '@reduxjs/toolkit';

import infoModalSlice from './modalSlice';
import waitingSlicer from './waitSlicer';
import authSlicer from './authSlice';
import pluginInfoSlicer from './pluginsSlice';
import panelSlicer from './panelSlicer';
import damaskSlicer from './eQueue/DamaskSlicer';
import enterSlicer from './eQueue/EnterSlicer';
import returnSlicer from './eQueue/ReturnSlicer';

import msgPanelSlicer from 'src/Modules/PushMessaging/Slicer';
import { wopiSlice } from 'src/Modules/Wopi/WopiSlice';

const rootReducer = () => {
	return combineReducers({
		modal: infoModalSlice.reducer,
		waiting: waitingSlicer.reducer,
		auth: authSlicer.reducer,
		pluginInfo: pluginInfoSlicer.reducer,
		panelState: panelSlicer.reducer,
		eQueueDamask: damaskSlicer.reducer,
		eQueueEnter: enterSlicer.reducer,
		eQueueReturn: returnSlicer.reducer,
		messagePanel: msgPanelSlicer.reducer,
		wopi: wopiSlice.reducer,
	});
};

export default rootReducer();
